import { NewInitiativeForm } from 'app/components/NewInitiativeForm/Loadable';

const NewInitiative = () => {
  return <NewInitiativeForm />;
};

export default NewInitiative;
